import { ReactNode } from "react";
import { Link as RouterLink } from "react-router-dom";
import { Box, Heading, HStack, Stack } from "@chakra-ui/react";

import { RoutesMap } from "../../../../routes.tsx";
import { useGetDebtStateQuery } from "../../../../api/debt";
import { useGetScheduleQuery } from "../../../../api/schedule";
import { MainPagePaymentScheduleContent } from "./Content";
import { MainPagePaymentScheduleError } from "./MainPagePaymentScheduleError";
import { MainPagePaymentSchedulePending } from "./MainPagePaymentSchedulePending";

export function MainPagePaymentSchedule(): ReactNode {
  const { data: schedule, isPending: isSchedulePending, isError: isScheduleError } = useGetScheduleQuery();
  const { isPending: isDebtPending, isError: isDebtError } = useGetDebtStateQuery();

  if (isSchedulePending || isDebtPending) {
    return <MainPagePaymentSchedulePending />;
  }

  if (isScheduleError || isDebtError) {
    return <MainPagePaymentScheduleError isScheduleError={isScheduleError} isDebtError={isDebtError} />;
  }

  if (!schedule?.periods?.length) {
    return null;
  }

  return (
    <Box
      as={RouterLink}
      to={RoutesMap.paymentsSchedule}
      bg="white"
      borderRadius="16px"
      px="20px"
      py="16px"
      w="100%"
    >
      <Stack spacing={1}>
        <HStack minH="38px" alignItems="center">
          <Heading flex="1" textAlign="left" size="md">График платежей</Heading>
        </HStack>

        <MainPagePaymentScheduleContent />
      </Stack>
    </Box>
  );
}
